import { Route } from "@angular/router";

export const communiqueRoutes: Route[] = [
  {
    path: 'list',
    loadComponent: () => import('./pages/list/list.component').then(c => c.ListComponent)
  },
  {
    path: 'create',
    loadComponent: () => import('./pages/create/create.component').then(c => c.CreateComponent)
  },
  {
    path: 'create-old',
    loadComponent: () => import('./pages/programming/programming.component').then(c => c.ProgrammingComponent)
  },
  { path: '**', redirectTo: 'list'}
]